<template>
  <lf-button
    class="rounded-sm"
    data-cy="primary-button"
    :class="{
      'cursor-not-allowed bg-disabled text-disabled-medium shadow-none':
        disabled,
      'bg-linear-to-bl from-primary-button-1 to-primary-button-2 shadow-primary-button hover:to-primary-button-hover-2 focus:to-primary-button-active active:from-primary-button-active active:to-primary-button-active':
        !disabled,
    }"
    :disabled="disabled"
  >
    <slot></slot>
  </lf-button>
</template>
<script setup lang="ts">
import LfButton from "@/components/ui/buttons/LfButton.vue";

defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>
